import React from 'react';
import { createRoot } from 'react-dom/client';

import { SchoolReviewForm } from '../main-app/components/ReviewForm';
import stores from '../main-app/stores';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-school-review-form');
  const root = createRoot(node);

  const renderForm = ({
    schoolId, placeId, userSchools, minCommentLength,
  }) => {
    root.render(
      <SchoolReviewForm schoolId={schoolId} userSchools={userSchools} placeId={placeId} minCommentLength={minCommentLength} />,
    );
  };

  if (!node) return;

  let schoolId = node.getAttribute('data-school-id');
  let placeId = node.getAttribute('data-place-id');
  let minCommentLength = node.getAttribute('data-school-min-comment-length');

  if (schoolId) {
    renderForm({ schoolId, placeId, minCommentLength });
  } else {
    const userSchools = JSON.parse(node.getAttribute('data-user-schools'));

    if (userSchools) {
      schoolId = userSchools[0].id;
      placeId = userSchools[0].placeId;
      minCommentLength = userSchools[0].min_comment_length;
      renderForm({
        schoolId, userSchools, placeId, minCommentLength,
      });
    } else {
      const callback = function (mutationsList) {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-school-id') {
            root.unmount();
            stores.schoolReviewStore.isSent = false;
            stores.meetingStore.meetingSubjects = [];

            schoolId = node.getAttribute('data-school-id');
            placeId = node.getAttribute('data-place-id');
            minCommentLength = node.getAttribute('data-school-min-comment-length');
            renderForm({ schoolId, placeId, minCommentLength });
          }
        });
      };

      const observer = new MutationObserver(callback);
      observer.observe(node, { attributes: true });
    }
  }
});
